import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import { CreateMastersData, EntitlementPackagesListResponse } from '../../Models'
import mainApiService from '../../Services'
import { setLoader } from './loader.slice'

interface EntitlementPackagesState {
  entitlementPackageData: EntitlementPackagesListResponse | null
}

const initialState: EntitlementPackagesState = {
  entitlementPackageData: null,
}

const entitlementPackagesSlice = createSlice({
  name: 'entitlementPackages',
  initialState,
  reducers: {
    setEntitlementPackagesData: (state, action) => {
      state.entitlementPackageData = action?.payload ? action.payload : null
    },
  },
})

export const { setEntitlementPackagesData } = entitlementPackagesSlice.actions

const entitlementPackagesSelector = (state: any) => state.entitlementPackages

export const selectEntitlementPackageData = createSelector(
  entitlementPackagesSelector,
  (state) => state.entitlementPackageData,
)

export const createEntitlementPackageService = createAsyncThunk(
  'entitlementPackages/create',
  async (payload: CreateMastersData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.MASTER_APIS.ADD_SYSTEM_CONFIG,
      {
        value: { key: payload.key, status: payload.status, value: payload.value },
        master: 'ENTITLEMENTPACKAGES',
      },
      { type: 'ENTITLEMENTPACKAGES' },
    )
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export const editEntitlementPackageService = createAsyncThunk(
  'entitlementPackages/editEntitlementPackage',
  async (payload: CreateMastersData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.MASTER_APIS.ADD_SYSTEM_CONFIG,
      {
        value: { key: payload.key, status: payload.status, value: payload.value },
        master: 'ENTITLEMENTPACKAGES',
        systemConfigId: payload?.id,
      },
      { type: 'ENTITLEMENTPACKAGES' },
    )
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export default entitlementPackagesSlice
